import wrapError from "@/components/helpers/wrapError"
import { httpPost } from "@/http"

export const loginAPI = async (email, password, success, error) => {
  await httpPost("loginManager", { email, password }, { success, error })
}

export const logoutApi = (success, error) => {
  $.ajax({
    method: "DELETE",
    url: "/api/loginManager",
    dataType: "JSON",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: "{}",
    success,
    error: wrapError(error, "logoutApi"),
  })
}

export const checkPasswordRules = (password, success, error) => {
  $.ajax({
    method: "POST",
    url: "/api/validPassword",
    dataType: "JSON",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify({
      password,
    }),
    success,
    error: wrapError(error, "checkPasswordRules"),
  })
}

export const requestAccess = (params, success, error) => {
  const payload = JSON.stringify({
    email: params.email,
    name: params.name,
    description: params.description,
    customerName: params.customerName,
  })

  $.ajax({
    type: "POST",
    url: "/api/accessManager",
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: payload,
    success,
    error: wrapError(error, "requestAccess"),
  })
}

export const forgotPassword = (email, success, error) => {
  $.ajax({
    method: "POST",
    url: "/api/forgottenPassword",
    dataType: "JSON",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify({
      email,
    }),
    success,
    error: wrapError(error, "forgotPassword"),
  })
}

const passwordTicket = (url) => (ticketId, firstPassword, secondPassword, success, error) => {
  $.ajax({
    method: "POST",
    url,
    dataType: "JSON",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify({
      ticketId,
      password: firstPassword,
      confirmPassword: secondPassword,
    }),
    success,
    error: wrapError(error, `passwordTicket ${url}`),
  })
}

export const changePassword = passwordTicket("/api/resetPassword")
export const createAccount = passwordTicket("/api/account")

export const apiFetchInitialState = (success, error) => {
  $.ajax({
    type: "GET",
    url: "/api/initialStateManager",
    dataType: "JSON",
    success,
    error: wrapError(error, "apiFetchInitialState"),
  })
}
